// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2krNt","upload":"Small_upload__3HITn","imageWrap":"Small_imageWrap__q0lpj","removeBtn":"Small_removeBtn__2cRt8"};